/**
 * HSN.Template
 **/
HSN.Template = (HSN.Template = HSN.Template || {});

HSN.Template.Checkout = (HSN.Template.Checkout = HSN.Template.Checkout || {});

HSN.Template.MyAccount = (HSN.Template.MyAccount = HSN.Template.MyAccount || {});

HSN.Template.AgentPortal = (HSN.Template.AgentPortal = HSN.Template.AgentPortal || {});

HSN.Template.DataRegulations = (HSN.Template.DataRegulations = HSN.Template.DataRegulations || {});


// WEBPACK FOOTER //
// ./assets/js/HSN/Template.js